<template>
  <div class="card h-100">
    <div class="card-header bg-darker">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex flex-row justify-content-start">
          <div class="position-relative">
            <img
              class="avatar rounded-circle"
              src="/img/persons/avatar-muted.png"
              :alt="user.name"
            />
            <icon-male
              v-if="user.gender == 'M'"
              class="position-absolute start-50 bottom-0 ms-2"
              alt="Male"
            />
            <icon-female
              v-if="user.gender == 'F'"
              class="position-absolute start-50 bottom-0 ms-2"
              alt="Female"
            />
          </div>
          <div class="d-flex flex-column ms-3">
            <div class="text-bold">{{ user.name }}</div>
            <div class="mt-1 text-xs text-muted text-uppercase">
              {{ user.platoon_name }} / {{ user.section_name }}
            </div>
          </div>
        </div>
        <router-link
          target="_blank"
          :to="{
            name: `User`,
            params: { udid: user.udid },
            query: { date: getDate()},
          }"
          exact
        >
          <icon-arrow-right />
        </router-link>
      </div>
    </div>
    <div class="card-body p-4">
      <user-profile-contributions
        v-if="contributions"
        :confidence="contributions.confidence"
        :dna-score="contributions.dna_score"
        :wellness-score="contributions.wellness_score"
        :profile-score="contributions.profile_score"
        :genetic-contributions="contributions.dna_contributions"
        :wellness-contributions="contributions.wellness_contributions"
        :display-dna="displayDna"
        :wellness-report="contributions.wellness_report"
      />
    </div>
  </div>
</template>

<script>
import DateUtils from "@/helpers/dateUtils";

import IconArrowRight from "@/shared/Controls/Icons/IconArrowRight.vue";
import IconMale from "@/shared/Controls/Icons/IconMale.vue";
import IconFemale from "@/shared/Controls/Icons/IconFemale.vue";
import UserProfileContributions from "./UserProfileContributions.vue";

export default {
  components: {
    IconArrowRight,
    IconMale,
    IconFemale,
    UserProfileContributions,
  },
  props: {
    dnaProfileId: {
      type: String,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    selectedCandidate: {
      type: Object,
      required: true,
    },
    displayDna: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      contributions: [],
    };
  },
  watch: {
    user() {
      this.getContributions(this.user.udid);
    },
  },
  mounted() {
    this.getContributions(this.user.udid);
  },
  methods: {
    getContributions(udid) {
      if (udid) {
        this.$store
          .dispatch("data/userDnaProfiles", {
            udid: udid,
            dna_profile_id: this.dnaProfileId,
          })
          .then(({ data }) => {
            this.contributions = [];
            if (data && data.length > 0) {
              this.contributions = data[0];
            }
          });
      }
    },
    getDate() {
     return DateUtils.formatDateToBucketDate()
    },
  },
};
</script>

<style></style>
